import { userPreferencesActionNames } from "./actions";

const initialState = {
  loggedIn: true,
  username: "j_doe",
  displayName: "Jon Doe",
  profilePicture: "https://t7.rbxcdn.com/b36a54c572d58a417dc2399761a3043e",
  email: "j_doe@email.com",
};

export const userPreferencesReducer = (state = initialState, action) => {
  switch (action.type) {
    case userPreferencesActionNames.SET_USERNAME: {
      return { ...state, username: action.payload };
    }
    case userPreferencesActionNames.SET_DISPLAYNAME: {
      return { ...state, displayName: action.payload };
    }
    case userPreferencesActionNames.SET_LOGIN_FLAG: {
      return { ...state, loggedIn: action.payload };
    }
    case userPreferencesActionNames.SET_EMAIL: {
      return { ...state, email: action.payload };
    }
    case userPreferencesActionNames.UPDATE_PROFILE_SETTINGS: {
      return {
        ...state,
        username: action.payload.username,
        displayName: action.payload.displayName,
        email: action.payload.email,
      };
    }
    default:
      return state;
  }
};
